import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  downloadReport,
  DownloadButton
} from '../../elements/ReportDownload';

import { cardStyles as styles } from './index';

const BlockReport = ({ data }) => {
  const [saleId, setSaleId] = useState(null);
  const [sellerId, setSellerId] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'block-report',
      params: { 'sale-id': saleId, 'seller-id': sellerId }
    });
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Block Report</Text>
      <Text style={styles.label}>Sale:</Text>
      <select style={styles.select} onChange={(e) => setSaleId(e.target.value)}>
        <option key="sale-nil" value="">Select Sale</option>
        {data.sales?.map(sale => (
          <option key={sale.id} value={sale.id}>{sale.name}</option>
        ))}
      </select>
      <Text style={styles.label}>Seller (optional):</Text>
      <select
        style={styles.select}
        onChange={(e) => setSellerId(e.target.value)}
      >
        <option key="seller-nil" value="">Select Seller</option>
        {data.sellers?.map(seller => (
          <option key={seller.id} value={seller.id}>
            {seller.fullDisplayName}
          </option>
        ))}
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  );
};

export default BlockReport;
